import { getAssetCategoryUiGroup } from '@repo/contracts';

export { mapColumnFiltersForQuery } from '../table-filter-query.js';

/** Query flag for GET /asset picker lists (skips list enrichment on the API). */
export const ASSET_LIST_PICKER_QUERY = Object.freeze({ picker: '1' });

export function readAssetPaginationTotal(pagination = {}) {
    const total = Number(pagination.total ?? pagination.totalItems);
    return Number.isInteger(total) && total >= 0 ? total : 0;
}

/**
 * Split a lean picker payload into the three dropdown buckets the asset form uses.
 * @param {Array<{ category?: string }>} assets
 */
export function splitAssetPickerRows(assets = []) {
    const rows = Array.isArray(assets) ? assets : [];
    return {
        assets: rows,
        locationAssets: rows.filter((row) => getAssetCategoryUiGroup(row?.category) === 'locationAssets'),
        infrastructureAssets: rows.filter((row) => getAssetCategoryUiGroup(row?.category) === 'infrastructureAssets'),
    };
}
